
<div class="containerDialog">
    <div  class="titleSecction">
        <h4 class="titleModal">Historial</h4>
    </div>
    <div class="mat-elevation-z8">
        <mat-table  [dataSource]="dataServices" matSort matTableExporter>

            <ng-container matColumnDef="nombreServicio">
                <mat-header-cell *matHeaderCellDef class="headerStyle"> Servicio </mat-header-cell>
                <mat-cell  at-cell *matCellDef="let element" class="bodyStyle"> 
                    <div> 
                        <div class="service-font-size">{{element.nombreServicio}} </div> 
                        <div *ngIf="element.historial?.length; else messageHistorialEmpty">
                            <ng-container *ngFor="let historial of  (element.historial)">
                                <p >  {{historial.service.nombreServicio}}  </p>
                            </ng-container>
                        </div>
                    </div>
                    <ng-template #messageHistorialEmpty>
                    <p> No hay historial</p>
                    </ng-template>     
                </mat-cell>
            </ng-container>



            <!-- Name Column -->
            <ng-container matColumnDef="tipoServicio">
                <mat-header-cell *matHeaderCellDef class="headerStyle"> Tipo de Servicio </mat-header-cell>
                <mat-cell mat-cell *matCellDef="let element" class="bodyStyle"> 

                    <div> 
                        <div class="service-font-size">{{element.tipoServicio}} </div>
                        <div *ngIf="element.historial?.length; else messageHistorialEmpty">
                            <ng-container *ngFor="let historial of  (element.historial)">
                                <p > {{historial.service.tipoServicio}} </p>
                            </ng-container>
                        </div>
                    </div>
                    <ng-template #messageHistorialEmpty>
                    <p> No hay historial</p>
                    </ng-template>     



                </mat-cell>
            </ng-container>



            <ng-container matColumnDef="proveedorServicio">
                <mat-header-cell *matHeaderCellDef class="headerStyle"> Proveedor </mat-header-cell>
                <mat-cell mat-cell *matCellDef="let element" class="bodyStyle"> 
                
                    <div> 
                        <div class="service-font-size">{{element.objProvider.nombre}} </div>
                        <div *ngIf="element.historial?.length; else messageHistorialEmpty">
                            <ng-container *ngFor="let historial of  (element.historial)">
                                <p > {{historial.service.objProvider?.nombre}} </p>
                            </ng-container>
                        </div>
                    </div>
                    <ng-template #messageHistorialEmpty>
                    <p> No hay historial</p>
                    </ng-template>     

                </mat-cell>
            </ng-container>


            <ng-container matColumnDef="fecha">
                <mat-header-cell *matHeaderCellDef class="headerStyle"> Fecha </mat-header-cell>
                <mat-cell mat-cell *matCellDef="let element" class="bodyStyle"> 
                    <div> 
                        <div class="service-font-size">-</div>

                            <div *ngIf="element.historial?.length; else messageHistorialEmpty">
                                <ng-container *ngFor="let historial of  (element.historial)">
                                    <p >{{historial.createdAt | date:'dd/MM/yyyy HH:mm:ss'}}  </p>
                                </ng-container>
                            </div>
                        </div>
                        <ng-template #messageHistorialEmpty>
                        <p> No hay fecha</p>
                        </ng-template>     

                </mat-cell>
            </ng-container>

        
            <ng-container matColumnDef="user">
                <mat-header-cell *matHeaderCellDef class="headerStyle"> User </mat-header-cell>
                <mat-cell mat-cell *matCellDef="let element" class="bodyStyle"> 
                    <div> 
                        <div class="service-font-size">-</div>

                            <div *ngIf="element.historial?.length; else messageHistorialEmpty">
                                <ng-container *ngFor="let historial of  (element.historial)">
                                    <p >{{historial.user }}  </p>
                                </ng-container>
                            </div>
                        </div>
                        <ng-template #messageHistorialEmpty>
                        <p> No hay user</p>
                        </ng-template>     

                </mat-cell>
            </ng-container>


            <mat-header-row *matHeaderRowDef="columnsTable"></mat-header-row>
            <mat-row class="align-items"  *matRowDef="let row; columns: columnsTable;"></mat-row>
        </mat-table>

        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

    <div style="margin-top: 2rem;" class="divCenter" >
        <button class="buttonSecundary" (click)="close()">Cerrar</button>
    </div>
</div>